export const getVideoDurationAndThumbnail = (
  file: File
): Promise<{ durationInSeconds: number; thumbnailBlob: Blob }> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = URL.createObjectURL(file);
    video.load();

    video.onerror = () => {
      reject('Error loading video file');
    };

    video.onloadedmetadata = () => {
      video.currentTime = 1;
      video.onseeked = () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        return ctx.canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve({
                durationInSeconds: video.duration,
                thumbnailBlob: blob,
              });
            } else {
              reject('Error creating thumbnail');
            }
            window.URL.revokeObjectURL(video.src);
          },
          'image/jpeg',
          0.75
        );
      };
    };
  });
};

export const getVideoDuration = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = URL.createObjectURL(file);
    video.load();

    video.onerror = () => {
      reject('Error loading video file');
    };

    video.onloadedmetadata = () => {
      resolve(video.duration);
      setTimeout(() => {
        window.URL.revokeObjectURL(video.src);
      }, 1000);
    };
  });
};
